import { parsePhoneNumber } from 'libphonenumber-js/min';

export const parsePhoneNumberIntoFormattedPhoneNumber = (value: string) => {
    const parsedPhoneNumber = parsePhoneNumber(value, 'PL');
    return parsedPhoneNumber.formatNational();
};
